/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useApiRequest, IResponsePayload } from '../../../hooks/useApiRequest';
import { URLS } from '../../../constants/urls.constants';
import { stopLoading } from '../../../store/modules/loading';
import { setAlert } from '../../../store/modules/snackbar';

interface IGet {}

const useGetUnits_Acts = (props: IGet) => {
	const dispatch = useDispatch<any>();
	const { execute, status, value, urlParams } = useApiRequest<
		any,
		IResponsePayload<any>
	>({
		path: URLS.PROJECT.SUPERVISION_UNIT,
		method: 'GET',
	});

	useEffect(() => {
		if (status === 'success') {
			dispatch(stopLoading());
		} else if (status === 'error') {
			dispatch(stopLoading());
			dispatch(
				setAlert({
					show: true,
					message: 'Ocurrio un error al crear el proyecto',
					severity: 'error',
				})
			);
		}
	}, [status]);

	return { execute, status, value, urlParams };
};

export default useGetUnits_Acts;
